module.exports = __webpack_public_path__ + "media/images/listras03-ad86c7d28b68e12a44239476027a6081.png";